import { ToggleControl } from './toggle-control.model';

export class RadioControl extends ToggleControl {

  constructor(id: string, label: string, value: boolean | undefined | null) {
    super(id, label, value);
    this.className = "RadioControl";
  }

}
